export class ModalHelper {
    static addClassToParent(ref, classname) {
        if (ref['_overlayRef'].overlayElement) {
            ref['_overlayRef'].overlayElement.parentElement.className += ` ${classname || 'modal-dialog-wrapper'}`;
        }
    }
}
